var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 457.47 79.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clip-path);}.cls-2,.cls-5,.cls-6{fill:none;}.cls-3{isolation:isolate;}.cls-4{clip-path:url(#clip-path-4);}.cls-5{clip-rule:evenodd;}.cls-6{fill-rule:evenodd;}.cls-7{clip-path:url(#clip-path-5);}.cls-8{clip-path:url(#clip-path-6);}.cls-9{clip-path:url(#clip-path-7);}.cls-10{opacity:0;}.cls-11{mask:url(#mask);}.cls-12{mask:url(#mask-2);}.cls-13{mask:url(#mask-3);}.cls-14{clip-path:url(#clip-path-16);}.cls-15{clip-path:url(#clip-path-17);}.cls-16{clip-path:url(#clip-path-18);}.cls-17{fill:#fff;}.cls-18{clip-path:url(#clip-path-20);}.cls-19{clip-path:url(#clip-path-22);}.cls-20{clip-path:url(#clip-path-24);}.cls-21{clip-path:url(#clip-path-26);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 146.51,
    y: 1.14,
    width: 65,
    height: 76
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 146.51,
    y: 1.14,
    width: 65,
    height: 76
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "146.51 1.14 146.51 76.19 211.46 76.19 211.46 56.74 173.53 56.74 173.53 47.88 204.37 47.88 204.37 29.91 173.53 29.91 173.53 20.58 211.46 20.58 211.46 1.14 146.51 1.14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -1245.53,
    y: -458.13,
    width: 1920,
    height: 1080
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 146.47,
    y: 0.87,
    width: 65,
    height: 76
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 147.51,
    y: 2.14,
    width: 65,
    height: 76,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, -1, 146.51, 77.14)",
    xlinkHref: "#image"
  })))), /*#__PURE__*/React.createElement("image", {
    id: "image",
    width: 65,
    height: 76,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAABMCAYAAAAyadqbAAAACXBIWXMAAAsSAAALEgHS3X78AAADlUlEQVR4Xu2YwW4jMQxDn7NF+/9f7D1k1WUYasa5i8BgbFnSyKLrFFx77wfwB/gGvv6N6/0DPGTuts7vS/Kp/UfylF/Zkp9+99vm5Ve2itdv1Np3yPf7jQcZWx7kXeNldrW5XaE5da7xnqf81a7QePc5in+IEzYueHD60OI1Vjeka8se94f3PN5wt9e8fK781P6Lhxi6AGdZoZvsTkJ3cq7yFtLJ0XdCIqneHr/g2QR3KNwVCPenyHFVoCOdwO7EpLGTk+I3PJtwx0glS03SD6jd/QrdUa1v6PiFLd5r8G8mf0VLsv85dEfPu1h29/FxzRO6TTl7vjmHE+E5b+P1Yuy67LjqeLfhghflOa7Yq+Ykn652/VZLRncxduyXX+fjm0qnp2NM3yn+jnFFIirlAv7fCeXonbtjFvp4XbuDx3an7DRfIk/jX/L4P0upc10Hq1HLHuhZSvE17hp3FZ/gjbuNObkYdezd9MI7pj6N9zxdLfBet8/VnrD0JHRd61h16KlweyGtq5+fKLfDdf6C5rlqyILXO8GRNq+Nqg94kVcf7Rjz+O7bHSHeNH20GX6KNjx/HTp4YoefnCtGOnTxifW7XKmhTl6MP70TdM19VnjreseeM5PqSOy5T62lDepp6OqguxOWPIVUpNu8EVfM1Xo9XUO6zRU8XtGtvcSPnsDoCcDoCQtGT9gwegJw9hNZTUosuo+Pa57QbcrZ8805nAjPeRs/egKjJwCjJwCjJwBnF6OOvZteeMfUp/Gep6sF3uv2udoTRk+A0RM2jJ4AnN8JuuY+K7x1vWPPmUl1JPbcp9bSBvU0dHWMngCjJwCjJwCjJywYPWHD6AnA2U9kNSmx6D4+rnlCtylnzzfncCI852386AmMngCMngCMngCcXYw69m564R1Tn8Z7nq4WeK/b52pPGD0BRk/YMHoCcH4n6Jr7rPDW9Y49ZybVkdhzn1pLG9TT0NUxegKMngCMngCMnrBg9IQNoycAZz+R1aTEovv4uOYJ3aacPd+cw4nwnLfxoycwegIwegIwegJwdjHq2LvphXdMfRrvebpa4L1un6s9YfQEGD1hw+gJwPmdoGvus8Jb1zv2nJlUR2LPfWotbVBPQ1fH6AkwegIwegIwesKC0RM2jJ4AnP1EVpMSi+7j45ondJty9nxzDifCc97Gj57A6AnA6AnA6AnA2cWoY++mF94x9Wm85+lqgfe6fa72hPUXE2IJwKYli3cAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 146.47,
    y: 0.87,
    width: 67,
    height: 78,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.47,
    y: -0.13,
    width: 67,
    height: 78
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, -1, 146.51, 77.14)",
    xlinkHref: "#image"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 147.47,
    y: 1.79,
    width: 65.04,
    height: 76.35,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, -1, 146.51, 77.14)",
    xlinkHref: "#image"
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 73.33,
    height: 77.33
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -0.53,
    y: -0.13,
    width: 74,
    height: 78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M57.41,2.62a47.56,47.56,0,0,1,15.92,9.32L61.48,28.43a34.59,34.59,0,0,0-10.63-6.88,33,33,0,0,0-12-2.1,15.05,15.05,0,0,0-6.51,1.19c-1.63.8-2.44,1.84-2.44,3.13,0,.84.78,1.48,2.32,1.93s4.27,1,8.14,1.71q16.86,3,24.23,8.92t7.38,16.78A20,20,0,0,1,67.41,66.3a27.82,27.82,0,0,1-12.32,8.25,51.71,51.71,0,0,1-17.44,2.78q-13.59,0-21.73-2.5A55.17,55.17,0,0,1,0,66.75l11.62-18a31.67,31.67,0,0,0,10.69,6.88,37.33,37.33,0,0,0,13.37,2.22c5.66,0,8.48-1.13,8.48-3.41q0-1.81-2.67-2.73a62.63,62.63,0,0,0-8.72-1.93,112.92,112.92,0,0,1-15-3.64A26.44,26.44,0,0,1,6.8,39.23Q2.09,34.34,2.09,25.81A22.53,22.53,0,0,1,6.28,12.28q4.17-5.79,12.26-9T38,0A62.8,62.8,0,0,1,57.41,2.62"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "253.95 48.21 247.68 56.6 247.68 76.22 220.63 76.22 220.63 1.38 247.68 1.38 247.68 29.27 267.65 1.38 296.44 1.38 272.99 31.09 298.53 76.22 268.23 76.22 253.95 48.21"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "369.61 56.83 369.61 76.22 304.5 76.22 304.5 1.38 369.61 1.38 369.61 20.77 331.59 20.77 331.59 30.07 362.51 30.07 362.51 47.98 331.59 47.98 331.59 56.83 369.61 56.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "146.42 56.83 146.42 76.22 81.31 76.22 81.31 1.38 146.42 1.38 146.42 20.77 108.4 20.77 108.4 30.07 139.32 30.07 139.32 47.98 108.4 47.98 108.4 56.83 146.42 56.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M412.57,51.38h-7.43V76.22H378.71V1.38h41.51q15.3,0,23.14,6.3t7.82,18.76q0,16.44-13.8,22.11l18.09,27.67H426.13ZM405.14,34h9.63c3.4,0,5.81-.52,7.25-1.54s2.14-2.82,2.14-5.38-.71-4.27-2.14-5.33-3.85-1.59-7.25-1.59h-9.63Z"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image-2",
    width: 271,
    height: 318,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQ8AAAE+CAYAAACTCZU2AAAACXBIWXMAAC4jAAAuIwF4pT92AAAD2klEQVR4Xu3UsQ0AIRDAsOf33/lYAAmR2q5TZ83MfACP/lsAcGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQGIeQLIBD9EGePdTeQ0AAAAASUVORK5CYII="
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(147.47 1.79) scale(0.24)",
    xlinkHref: "#image-2"
  }))))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(147.47 1.79) scale(0.24)",
    xlinkHref: "#image-2"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    width: 75.34,
    height: 79.33
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 220.63,
    y: 1.38,
    width: 79.9,
    height: 76.83
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 304.5,
    y: 1.38,
    width: 67.11,
    height: 76.83
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 81.31,
    y: 1.38,
    width: 67.11,
    height: 76.83
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 378.71,
    y: 1.38,
    width: 78.76,
    height: 76.83
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d83fb2c67bcb8095f832d6ef86497131.svg";
export { ForwardRef as ReactComponent };